import { createRouter, createWebHashHistory } from 'vue-router'

// 静态路由（无需权限）
export const staticRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', hidden: true },
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/error/403.vue'),
    meta: { title: '无权限', hidden: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '页面不存在', hidden: true },
  },
]

// 动态路由映射（根据菜单数据动态注册）
export const dynamicRouteMap = {

  // 'system/user/index': () => import('@/views/system/user/index.vue'),
  // 'system/role/index': () => import('@/views/system/role/index.vue'),
  // 'system/menu/index': () => import('@/views/system/menu/index.vue'),
  'shop/index': () => import('@/views/shop/index.vue'),
  'finance/index': () => import('@/views/finance/index.vue'),
  'goods/index':   () => import('@/views/goods/index.vue'),
  'order/index':   () => import('@/views/order/index.vue'),
}

const router = createRouter({
  history: createWebHashHistory(),
  routes: staticRoutes,
  scrollBehavior: () => ({ top: 0 }),
})

export default router
